<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs geofence_apps" style="position: relative;">
    <app-loader [showLoader]=showLoad></app-loader>
    <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap "
     style="position: relative;">
      <div class="o-stack__cell">
        <h5>{{sectiontitle}}</h5>
        <a href="#" class="datatable_download_icon" *ngIf="downloadConfiguration && downloadConfiguration.enableDownload" (click)="downloadDataInCSV($event)" target="_blank">
          <img src="../../../../../assets/images/Download_Icon.svg"/>
         </a>
      </div>
    </div>
    <div class="analytics-portlet-content">
  
      <ngx-datatable class="v5datatable" [columns]="columns" [rows]="geofenceAppData" [sortType]="'single'" [columnMode]="'force'"
       [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'" [limit]="10" [reorderable]="reorderable">
      </ngx-datatable>
      <ng-template #appNameTemplate let-row="row" let-value="value" let-column="column">
        <span class="tooltip">
          {{value}}<span class="tooltiptext">{{row.appName}}</span>
        </span>
      </ng-template>
      <div class="no-data-container" *ngIf="!hasData">
        <div class="c-portlet__header o-stack o-stack--center o-stack--splitted  u-px-small u-py-mini c-portlet-gap pos-relative">
          <div class="o-stack__cell">
            <h5>{{sectiontitle}}</h5>
          </div>
        </div>
        <div class="map-no-data">No Data to Display</div>
      </div>
    </div>
  </div>
  